import React from "react";

import { CONSENT_STATUS } from "@utils/enum";

import {
  IconDetailsByStatus,
  TextDetailsByStatus,
} from "./ProvideConsentCard.constants";

export const useProvideConsentCard = ({ consentStatus, onProvideConsent }) => {
  const [isQuestionDialogVisible, setIsQuestionDialogVisible] =
    React.useState(false);
  const [isSuccessDialogVisible, setIsSuccessDialogVisible] =
    React.useState(false);

  const IconDetails = React.useMemo(
    () => IconDetailsByStatus[consentStatus],
    [consentStatus]
  );

  const TextDetails = React.useMemo(
    () => TextDetailsByStatus[consentStatus],
    [consentStatus]
  );

  const isPendingConsent = React.useMemo(
    () => consentStatus === CONSENT_STATUS.PENDING,
    [consentStatus]
  );

  const handleOpenQuestionDialog = () => {
    setIsQuestionDialogVisible(true);
  };

  const handleCloseQuestionDialog = () => {
    setIsQuestionDialogVisible(false);
  };

  const handleOpenSuccessDialog = () => {
    setIsSuccessDialogVisible(true);
  };

  const handleCloseSuccessDialog = () => {
    setIsSuccessDialogVisible(false);
  };

  const handleUpdateConsent = React.useCallback(async () => {
    handleCloseQuestionDialog();

    const success = await onProvideConsent();

    if (!success) {
      return;
    }

    handleOpenSuccessDialog();
  }, [onProvideConsent]);

  return {
    isQuestionDialogVisible,
    isSuccessDialogVisible,
    handleOpenQuestionDialog,
    handleCloseQuestionDialog,
    handleCloseSuccessDialog,
    handleUpdateConsent,
    isPendingConsent,
    IconDetails,
    TextDetails,
  };
};
